<script setup>

const isFixed = ref(false);
const isHidden = ref(true);
const buttonY = ref(0);
const buttonHeight = ref(0);
const bottomMargin = 20;

const buttonPosition = () => {
  const button = document.querySelector('.sticky-btn');
  if (!button) return;
  
  buttonY.value = button.getBoundingClientRect().top + window.scrollY;
  buttonHeight.value = button.clientHeight;
  
  if (window.innerHeight <= buttonY.value + buttonHeight.value) {
    isFixed.value = true;
    window.addEventListener('scroll', handleScroll);
  } else {
    isFixed.value = false;
    window.removeEventListener('scroll', handleScroll);
  }
};

const handleScroll = () => {
  if ((window.scrollY + window.innerHeight - bottomMargin - buttonHeight.value) > buttonY.value && isFixed.value) {
    isFixed.value = false;
  } 
  if ((window.scrollY + window.innerHeight - bottomMargin - buttonHeight.value) < buttonY.value && !isFixed.value) {
    isFixed.value = true;
  }
};

const debounce = (callback, delay) => {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(callback, delay);
  };
};

const handleResize = debounce(buttonPosition, 250);

onMounted(() => {
  nextTick(() => {
    buttonPosition();
    isHidden.value = false;
  });
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('resize', handleResize);
});
</script>
<template>
  <div>
    <div 
      class="sticky-btn z-[9999] block"
      :class="{
        'fixed bottom-6 left-1/2 transform -translate-x-1/2 transition-opacity duration-200': isFixed,
        'opacity-0': isHidden 
      }"
    >
      <slot></slot>
    </div>
      <div v-if="isFixed" :style="{ height: `${buttonHeight}px` }"></div>
  </div>
</template>